<template>
    <div CLASS="overview-background">
        <v-container id="overview" style="text-align: center;">
            <v-layout row wrap justify-center align-center class="mt-3">
                <v-layout row wrap justify-center align-center style="max-width: 650px;">
                    <v-flex xs12 class="deep-purple--text text--darken-3 overview-headline" style="font-weight: 900">
                        A Powerful, Comprehensive Platform For The Modern Business.
                    </v-flex>
                    <v-flex xs12 class="grey--text text--darken-3 overview-subheadline">
                        Equip your company with a fast and capable platform that offers a wide variety of tools
                        to help your business handle more clients and earn more revenue.
                    </v-flex>
                    <v-flex xs12>
                        <v-layout row wrap justify-center class="pt-3">
                            <icon-base
                                    viewBox="0 0 706.148 705.636"
                                    width="500"
                                    height="500"
                            >
                                <icon-erp/>
                            </icon-base>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-layout>
        </v-container>
        <v-container class="text-xs-center mt-0 pt-0" style="max-width: 1300px;">
            <v-layout row wrap justify-center align-center class="overview-icons-container">
                <v-flex xs12 sm4>
                    <v-card flat class="py-5 mx-2" style="border-radius: 2px">
                        <icon-base
                                class="py-2"
                                viewBox="0 0 1920 1080"
                                width="100%"
                                height="100px"
                        >
                            <icon-crm/>
                        </icon-base>
                        <div class="overview-icons--text grey--text text--darken-3 py-2"><b>Advanced CRM</b></div>
                        <div class="overview-icons--text2 grey--text text--darken-3 py-2">Easily manage your clients.
                        </div>
                        <v-btn flat class="indigo--text" @click="changeLocation('/contact-us')">Learn More ></v-btn>
                    </v-card>
                </v-flex>
                <v-flex xs12 sm4>
                    <v-card flat class="py-5 mx-2" style="border-radius: 2px">
                        <icon-base
                                class="py-2"
                                viewBox="0 0 1920 1080"
                                width="100%"
                                height="100px"
                        >
                            <icon-salesOrdering/>
                        </icon-base>
                        <div class="overview-icons--text grey--text text--darken-3 py-2"><b>Sales Ordering</b>
                        </div>
                        <div class="overview-icons--text2 grey--text text--darken-3 py-2">Wholesale order & production
                            management.
                        </div>
                        <v-btn flat class="indigo--text" @click="changeLocation('/contact-us')">Learn More ></v-btn>
                    </v-card>
                </v-flex>
                <v-flex xs12 sm4>
                    <v-card flat class="py-5 mx-2" style="border-radius: 2px">
                        <icon-base
                                class="py-2"
                                viewBox="0 0 512 512"
                                width="100%"
                                height="100px"
                        >
                            <icon-clientPortal/>
                        </icon-base>
                        <div class="overview-icons--text grey--text text--darken-3 py-2"><b>Client Portal</b></div>
                        <div class="overview-icons--text2 grey--text text--darken-3 py-2">Online orders & invoicing.
                        </div>
                        <v-btn flat class="indigo--text" @click="changeLocation('/contact-us')">Learn More ></v-btn>
                    </v-card>
                </v-flex>
                <v-flex xs12 class="my-5 pt-5">
                    <v-layout row wrap>
                        <v-flex xs12 md6 style="text-align: left">
                            <div class="indigo--text overview-icons--text pt-5">
                                <b>Build a powerful, efficient ERP system that drives revenue.</b>
                            </div>
                            <div class="overview-icons--text2 pt-5">
                                Enable clients to manage their own orders. <br>
                                Customise your sales order system, automate repetitive tasks. <br>
                                Analyze your data to seamlessly manage your sales cycle and production.
                            </div>
                        </v-flex>
                        <v-flex xs12 md6 class="sm-image-top-padding">
                            <img src="https://vorsi-home.s3.amazonaws.com/images/Vorsi-SalesOrder-Screenshot.png"
                                 alt="" style="height: auto; width: 80%">
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import IconBase from '../../components/icons/IconBase.vue'
    import IconCrm from '../../components/icons/IconCrm.vue'
    import IconSalesOrdering from '../../components/icons/IconSalesOrdering.vue'
    import IconClientPortal from '../../components/icons/IconClientPortal.vue'
    import IconErp from '../../components/icons/IconErp.vue'

    export default {
        components: {
            IconBase,
            IconCrm,
            IconSalesOrdering,
            IconClientPortal,
            IconErp,
        },
        methods: {
            changeLocation(route) {
                window.location = route
            },
        }
    }
</script>